import React, { FC } from 'react';
import { TooltipProps } from 'antd/lib/tooltip';

import { StyledTooltip } from './styled';

export const BlackTooltip: FC<TooltipProps> = props => <StyledTooltip color='black' {...props} />;
